(function () {
  'use strict';

  var syncTimer = null;
  var isSyncInProgress = false;
  var handlersBound = false;
  var suppressBuildSync = false;
  var cachedPlus1Max = null;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readPlus1Meta() {
    var meta = document.querySelector('.jsc-manual-gwp-plus1-meta[data-manual-gwp-plus1-max]');
    if (!meta) {
      meta = document.querySelector('[data-manual-gwp-plus1-max]');
    }

    if (!meta) {
      return null;
    }

    var max = parseInt(meta.getAttribute('data-manual-gwp-plus1-max'), 10);
    var qty = parseInt(meta.getAttribute('data-manual-gwp-plus1-qualifying-qty'), 10);
    var bonus = parseInt(meta.getAttribute('data-manual-gwp-plus1-bonus'), 10);
    var qualified = meta.getAttribute('data-manual-gwp-plus1-qualified') === 'true';
    var lineType = meta.getAttribute('data-manual-gwp-plus1-line-type') || '';

    // Prefer Liquid max; fall back to qty + bonus when max attr is missing/invalid
    if ((Number.isNaN(max) || max < 0) && !Number.isNaN(qty) && qty >= 0) {
      if (Number.isNaN(bonus) || bonus < 0) {
        bonus = 1;
      }
      max = qty + bonus;
    }

    if (Number.isNaN(max) || max < 1) {
      max = null;
    }

    return {
      max: max,
      qty: Number.isNaN(qty) ? null : qty,
      bonus: Number.isNaN(bonus) ? null : bonus,
      lineType: lineType,
      qualified: qualified
    };
  }

  function getPlus1LineType() {
    var meta = readPlus1Meta();
    if (meta && meta.lineType) {
      return meta.lineType;
    }
    if (window.jscManualGwpPlus1LineType && window.jscManualGwpPlus1LineType['1']) {
      return window.jscManualGwpPlus1LineType['1'];
    }
    return 'Free Gift';
  }

  function updateCachedPlus1MaxFromDom() {
    var meta = readPlus1Meta();
    if (!meta) {
      return cachedPlus1Max;
    }

    // Drop cache when no longer qualified so removals are not blocked.
    if (meta.qualified === false || meta.qty === 0) {
      cachedPlus1Max = null;
      return cachedPlus1Max;
    }

    // Always adopt a fresh qualified max (including increases).
    if (meta.qualified && meta.max != null && meta.max >= 1) {
      cachedPlus1Max = meta.max;
    }

    return cachedPlus1Max;
  }

  function getPlus1Max() {
    updateCachedPlus1MaxFromDom();

    var meta = readPlus1Meta();
    if (meta && meta.qualified && meta.max != null && meta.max >= 1) {
      return meta.max;
    }

    if (cachedPlus1Max != null && cachedPlus1Max >= 1) {
      return cachedPlus1Max;
    }

    var container = document.querySelector('.jsc-choose-gwp-plus1-container[data-gwp-max-qty]');
    if (container) {
      var fromContainer = parseInt(container.getAttribute('data-gwp-max-qty'), 10);
      if (!Number.isNaN(fromContainer) && fromContainer >= 1) {
        return fromContainer;
      }
    }

    var actions = document.querySelector('.jsc-manual-gwp__actions[data-manual-gwp-plus1-actions][data-gwp-max-qty]');
    if (actions) {
      var fromActions = parseInt(actions.getAttribute('data-gwp-max-qty'), 10);
      if (!Number.isNaN(fromActions) && fromActions >= 1) {
        return fromActions;
      }
    }

    // Unknown — callers must not treat this as "max 1".
    return null;
  }

  function syncPlus1CartQtyControls() {
    var maxQty = getPlus1Max();
    if (maxQty == null || maxQty < 1) {
      return;
    }

    document.querySelectorAll('[data-manual-gwp-plus1-qty]').forEach(function (wrapper) {
      wrapper.setAttribute('data-manual-gwp-max', String(maxQty));

      var input = wrapper.querySelector('.js-qty__num');
      var plusBtn = wrapper.querySelector('.js-qty__adjust--plus');
      var minusBtn = wrapper.querySelector('.js-qty__adjust--minus');
      var currentQty = input ? parseInt(input.value, 10) : 0;
      if (Number.isNaN(currentQty)) {
        currentQty = 0;
      }

      // Shared max across multiple plus1 lines: leave headroom for siblings
      var otherQty = 0;
      document.querySelectorAll('[data-manual-gwp-plus1-qty] .js-qty__num').forEach(function (otherInput) {
        if (input && otherInput === input) {
          return;
        }
        var q = parseInt(otherInput.value, 10);
        if (!Number.isNaN(q) && q > 0) {
          otherQty += q;
        }
      });

      var lineMax = maxQty - otherQty;
      if (lineMax < 1) {
        lineMax = 1;
      }

      if (input) {
        input.setAttribute('max', String(lineMax));
        input.setAttribute('data-manual-gwp-max', String(lineMax));
      }
      wrapper.setAttribute('data-manual-gwp-max', String(lineMax));

      if (plusBtn) {
        plusBtn.disabled = currentQty >= lineMax;
      }
      if (minusBtn) {
        minusBtn.disabled = currentQty <= 1;
      }
    });

    // Keep chooser ATC capacity in sync when max rises
    document.querySelectorAll('.jsc-manual-gwp__actions[data-manual-gwp-plus1-actions]').forEach(function (actions) {
      actions.setAttribute('data-gwp-max-qty', String(maxQty));
      var qtyTotal = parseInt(actions.getAttribute('data-gwp-qty-total') || '0', 10);
      if (Number.isNaN(qtyTotal)) {
        qtyTotal = 0;
      }
      var atCapacity = qtyTotal >= maxQty;
      actions.setAttribute('data-gwp-at-capacity', atCapacity ? 'true' : 'false');

      var atc = actions.querySelector('.jsc-gwp-plus1-grid-atc');
      if (atc) {
        atc.setAttribute('data-gwp-at-capacity', atCapacity ? 'true' : 'false');
        if (atCapacity) {
          atc.classList.remove('cursor');
          atc.classList.add('jsc-not-allowed');
        } else if (atc.getAttribute('data-gwp-selected') !== 'true' && atc.getAttribute('data-avail') !== 'false') {
          atc.classList.add('cursor');
          atc.classList.remove('jsc-not-allowed');
        }
      }
    });

    var chooser = document.querySelector('.jsc-choose-gwp-plus1-container');
    if (chooser) {
      chooser.setAttribute('data-gwp-max-qty', String(maxQty));
    }
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function getMainCartSectionId() {
    var section = document.querySelector('[data-section-type="main-cart"]');
    if (section && section.dataset.sectionId) {
      return section.dataset.sectionId;
    }

    return 'main';
  }

  function hasPromoHookValue(selector) {
    return Array.from(document.querySelectorAll(selector)).some(function (el) {
      return (el.value || '').trim().length > 0;
    });
  }

  function cartNeedsPromoAction() {
    return hasPromoHookValue('.jsc-cart-gift-manual-plus1-remove');
  }

  function collectPromoLineKeys(selector) {
    var keys = [];
    document.querySelectorAll(selector).forEach(function (el) {
      var key = (el.value || '').trim();
      if (key) {
        keys.push(key);
      }
    });
    return keys;
  }

  async function executePromoCartActions() {
    var lineKeys = collectPromoLineKeys('.jsc-cart-gift-manual-plus1-remove');
    var uniqueLineKeys = Array.from(new Set(lineKeys));

    if (uniqueLineKeys.length === 0) {
      return false;
    }

    var updates = {};
    uniqueLineKeys.forEach(function (key) {
      updates[key] = 0;
    });

    var response = await fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    if (!response.ok) {
      console.error('Failed to remove Manual GWP +1 line items');
      return false;
    }

    return true;
  }

  async function refreshPlus1Section() {
    if (!isCartPage()) {
      return false;
    }

    var container = document.querySelector('div[data-manual-gwp-plus1]:not([data-manual-gwp-plus1-card]):not(.jsc-choose-gwp-plus1-container)');
    if (!container) {
      container = document.querySelector('[data-manual-gwp-plus1-root]');
    }
    if (!container) {
      // Fall back to first mount wrapper used in section-main-cart
      var all = document.querySelectorAll('[data-manual-gwp-plus1]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].hasAttribute('data-manual-gwp-plus1-root') || all[i].classList.contains('jsc-manual-gwp-plus1-root')) {
          container = all[i];
          break;
        }
      }
    }
    if (!container) {
      return false;
    }

    var sectionId = getMainCartSectionId();
    var url = cartRoot() + 'cart?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now();

    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) {
        return false;
      }

      var html = await response.text();
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var updated = parsed.querySelector('[data-manual-gwp-plus1-root]') || parsed.querySelector('div[data-manual-gwp-plus1]');

      if (updated) {
        container.innerHTML = updated.innerHTML;
        updateCachedPlus1MaxFromDom();
        syncPlus1CartQtyControls();
        initPlus1ScrollNav();
        return true;
      }
    } catch (error) {
      console.error('Error refreshing Manual GWP +1 section:', error);
    }

    return false;
  }

  async function rebuildCartProducts() {
    suppressBuildSync = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
    } finally {
      setTimeout(function () {
        suppressBuildSync = false;
      }, 100);
    }
  }

  async function checkPlus1Max() {
    try {
      var maxQty = getPlus1Max();
      if (maxQty == null) {
        return false;
      }

      var response = await fetch(cartRoot() + 'cart.js');
      if (!response.ok) {
        return false;
      }

      var cart = await response.json();
      var plus1Items = [];
      var totalQty = 0;

      cart.items.forEach(function (item) {
        var properties = item.properties || {};
        // Any non-blank Plus1 marker (Free Gift, Add-on, or legacy) counts
        if (!properties['_Cart_GWP_Manual_Plus1']) {
          return;
        }

        if (!properties['_Cart_Gift_Manual_Plus1']) {
          return;
        }

        plus1Items.push(item);
        totalQty += item.quantity;
      });

      if (totalQty <= maxQty) {
        return false;
      }

      var updateList = {};
      var excess = totalQty - maxQty;

      for (var j = plus1Items.length - 1; j >= 0 && excess > 0; j--) {
        var lineItem = plus1Items[j];
        if (lineItem.quantity <= excess) {
          updateList[lineItem.key] = 0;
          excess -= lineItem.quantity;
        } else {
          updateList[lineItem.key] = lineItem.quantity - excess;
          excess = 0;
        }
      }

      if (Object.keys(updateList).length === 0) {
        return false;
      }

      await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updateList })
      });

      return true;
    } catch (error) {
      console.error('Manual GWP +1 max qty check error:', error);
      return false;
    }
  }

  async function syncCartAndPromo() {
    if (isSyncInProgress) {
      return;
    }

    isSyncInProgress = true;

    try {
      var cartChanged = false;

      await refreshPlus1Section();
      updateCachedPlus1MaxFromDom();

      // Always honor Liquid remove hooks (e.g. qualifier removed → drop add-ons)
      if (cartNeedsPromoAction()) {
        cartChanged = (await executePromoCartActions()) || cartChanged;
      }

      var maxAdjusted = await checkPlus1Max();
      if (maxAdjusted) {
        cartChanged = true;
      }

      if (cartChanged) {
        await rebuildCartProducts();
        await refreshPlus1Section();
        updateCachedPlus1MaxFromDom();
      }

      syncPlus1CartQtyControls();
    } catch (error) {
      console.error('Manual GWP +1 sync error:', error);
    } finally {
      isSyncInProgress = false;
    }
  }

  function scheduleCartSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncCartAndPromo();
    }, 50);
  }

  function selectPlus1Variant(button) {
    var card = button.closest('[data-manual-gwp-plus1-card]');
    if (!card) {
      return;
    }

    if (button.disabled || button.classList.contains('is-unavailable') || button.classList.contains('is-at-capacity')) {
      return;
    }

    card.querySelectorAll('.jsc-manual-gwp-plus1__variant').forEach(function (pill) {
      pill.classList.remove('is-active');
    });
    button.classList.add('is-active');

    var variantId = button.getAttribute('data-variant-id');
    var actions = card.querySelector('.jsc-manual-gwp__actions');
    var atc = card.querySelector('.jsc-gwp-plus1-grid-atc');

    if (actions) {
      actions.setAttribute('data-selected-variant-id', variantId);
    }

    if (atc) {
      atc.setAttribute('data-prod-id', variantId);
      atc.setAttribute('data-avail', button.getAttribute('data-variant-available'));
    }

    var variantImage = button.getAttribute('data-variant-image');
    if (variantImage) {
      var image = card.querySelector('.jsc-manual-gwp__image');
      if (image) {
        image.src = variantImage;
        if (image.srcset) {
          image.srcset = variantImage;
        }
      }
    }
  }

  async function addPlus1ToCart(el) {
    if (!el.classList.contains('cursor') || el.classList.contains('jsc-not-allowed')) {
      return;
    }

    if (el.getAttribute('data-gwp-at-capacity') === 'true') {
      return;
    }

    if (el.getAttribute('data-avail') === 'false') {
      return;
    }

    var root = el.closest('.jsc-manual-gwp__actions');
    var variantId = (root && root.getAttribute('data-selected-variant-id')) || el.getAttribute('data-prod-id');
    var promoNo = el.getAttribute('data-promo') || (root && root.getAttribute('data-promo')) || '1';

    if (!variantId) {
      return;
    }

    var maxQty = parseInt((root && root.getAttribute('data-gwp-max-qty')) || '', 10);
    if (Number.isNaN(maxQty) || maxQty < 1) {
      maxQty = getPlus1Max();
    }
    if (maxQty == null || maxQty < 1) {
      maxQty = 1;
    }

    var currentQty = parseInt((root && root.getAttribute('data-gwp-qty-total')) || '0', 10);
    if (Number.isNaN(currentQty) || currentQty < 0) {
      currentQty = 0;
    }

    if (currentQty >= maxQty) {
      return;
    }

    var gwpLabel = el.getAttribute('data-gwp-label');
    if (!gwpLabel && window.jscManualGwpPlus1Label) {
      gwpLabel = window.jscManualGwpPlus1Label[String(promoNo)] || '';
    }

    el.classList.remove('cursor');
    el.classList.add('jsc-not-allowed');
    var buttonText = el.querySelector('.btn');
    if (buttonText) {
      buttonText.textContent = '加入購物車...';
    }

    var properties = {
      _Cart_Gift_Manual_Plus1: String(promoNo),
      _Cart_GWP_Manual_Plus1: getPlus1LineType()
    };

    if (gwpLabel) {
      properties._Manual_GWP_Plus1_Label = gwpLabel;
    }

    var gwpDiscount = el.getAttribute('data-gwp-discount');
    if (gwpDiscount) {
      properties._Manual_GWP_Discount = gwpDiscount;
    }

    try {
      var response = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add Manual GWP +1');
      }

      await rebuildCartProducts();
      scheduleCartSync();
    } catch (error) {
      console.error('Manual GWP +1 add error:', error);
      el.classList.add('cursor');
      el.classList.remove('jsc-not-allowed');
      if (buttonText) {
        buttonText.textContent = '+ Add';
      }
    }
  }

  async function removePlus1FromCart(el) {
    var lineKey = el.getAttribute('data-line-key');
    if (!lineKey) {
      return;
    }

    el.disabled = true;

    try {
      var updates = {};
      updates[lineKey] = 0;

      var response = await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) {
        throw new Error('Failed to remove Manual GWP +1');
      }

      await rebuildCartProducts();
      scheduleCartSync();
    } catch (error) {
      console.error('Manual GWP +1 remove error:', error);
      el.disabled = false;
    }
  }

  function isPlus1ScrollLayout(container) {
    var desktop = container.getAttribute('data-layout-desktop') || 'stacked';
    var mobile = container.getAttribute('data-layout-mobile') || 'scroll';
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    return isMobile ? mobile === 'scroll' : desktop === 'scroll';
  }

  function initPlus1Scroll(container) {
    var wrap = container.querySelector('[data-manual-gwp-plus1-scroll]');
    var prev = container.querySelector('.jsc-manual-gwp__nav-btn--prev');
    var next = container.querySelector('.jsc-manual-gwp__nav-btn--next');

    if (!wrap || !prev || !next) {
      return;
    }

    function updateNavState() {
      if (!isPlus1ScrollLayout(container)) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      var maxScroll = wrap.scrollWidth - wrap.clientWidth;

      if (maxScroll <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      prev.disabled = wrap.scrollLeft <= 1;
      next.disabled = wrap.scrollLeft >= maxScroll - 1;
    }

    function scrollByDirection(direction) {
      var card = wrap.querySelector('.jsc-manual-gwp__card');
      var gap = 12;
      var amount = card ? card.offsetWidth + gap : Math.round(wrap.clientWidth * 0.85);

      wrap.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      if (!prev.disabled) {
        scrollByDirection(-1);
      }
    });

    next.addEventListener('click', function () {
      if (!next.disabled) {
        scrollByDirection(1);
      }
    });

    wrap.addEventListener('scroll', updateNavState, { passive: true });
    updateNavState();
  }

  function initPlus1ScrollNav() {
    document.querySelectorAll('.jsc-choose-gwp-plus1-container').forEach(initPlus1Scroll);
  }

  function bindHandlers() {
    if (handlersBound) {
      return;
    }
    handlersBound = true;

    document.addEventListener('click', function (event) {
      var variantBtn = event.target.closest('.jsc-manual-gwp-plus1__variant');
      if (variantBtn) {
        event.preventDefault();
        selectPlus1Variant(variantBtn);
        return;
      }

      var atcBtn = event.target.closest('.jsc-gwp-plus1-grid-atc.cursor');
      if (atcBtn) {
        event.preventDefault();
        addPlus1ToCart(atcBtn);
        return;
      }

      var removeBtn = event.target.closest('.jsc-gwp-plus1-remove-from-cart');
      if (removeBtn) {
        event.preventDefault();
        removePlus1FromCart(removeBtn);
      }
    });

    document.addEventListener('cart:updated', scheduleCartSync);
    document.addEventListener('cart:build', function () {
      if (suppressBuildSync) {
        return;
      }
      scheduleCartSync();
    });
  }

  async function syncBeforeCheckout() {
    await refreshPlus1Section();
    updateCachedPlus1MaxFromDom();

    var cartChanged = false;

    if (cartNeedsPromoAction()) {
      cartChanged = (await executePromoCartActions()) || cartChanged;
    }

    if (await checkPlus1Max()) {
      cartChanged = true;
    }

    if (cartChanged) {
      await rebuildCartProducts();
      await refreshPlus1Section();
      updateCachedPlus1MaxFromDom();
    }

    syncPlus1CartQtyControls();
  }

  function init() {
    bindHandlers();
    updateCachedPlus1MaxFromDom();
    initPlus1ScrollNav();

    if (isCartPage()) {
      syncCartAndPromo();
    }
  }

  window.jscManualGwpPlus1SyncBeforeCheckout = syncBeforeCheckout;
  window.scheduleManualGwpPlus1CartSync = scheduleCartSync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
